<template>
  <tr>
    <td v-if="!isExpense">
      <memlist-checkbox 
        v-model="local_row.apply"
        :disabled="true"
      />
    </td>
    <td>
      <memlist-text-input
        id="input-name"
        v-model="local_row.name"
        type="text"
        @input="onNameUpdated"
        :disabled="isDisabled"
      />
    </td>
    <td>
      <memlist-text-input
        id="input-amount"
        v-model="local_row.amount"
        type="text"
        @input="onSumUpdated"
        :disabled="isDisabled"
      />
    </td>
    <td class="text-right pr-0">

      <a v-if="enableDelete && !isDisabled" class="btn btn-icon btn-light btn-sm" @click="delete_row_clicked(local_row.id)">
        <span class="svg-icon svg-icon-md svg-icon-primary">
          <!--begin::Svg Icon-->
          <inline-svg src="/assets/svg/trash2.svg"></inline-svg>
          <!--end::Svg Icon-->
        </span>
      </a>
    </td>
  </tr>
</template>
<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  name: 'GrantBudgetTableRow',
  props: ['row','isDisabled','isExpense'],
  emits: ['onRowChanged', 'delete_row_clicked'],
  computed: {
    ...mapGetters(['currentCompanyId'])
  },
  data() {
    return {
      enableDelete: true,
      local_row: {},
    };
  },
  mounted() {
    
  },

  watch: {
    row: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_row = { ...this.row };
      },
      immediate: true
    },
  },

  methods: {
    delete_row_clicked(id) {
      this.$emit('delete_row_clicked', id);
    },
    onSumUpdated(evt) {
      this.local_row.amount = parseInt(this.local_row.amount+'');

      if (isNaN(this.local_row.amount)) {
        this.local_row.amount = 0;
      }

      this.$emit('onRowChanged', this.local_row);
    },
    onNameUpdated() {
      this.local_row.amount = parseInt(this.local_row.amount+'');

      if (isNaN(this.local_row.amount)) {
        this.local_row.amount = 0;
      }

      this.$emit('onRowChanged', this.local_row);
    }
  }
};
</script>
